import styled from 'styled-components';
import {
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_PAGE_MARGIN_2_XL,
  SYS_PAGE_MARGIN_MD,
  SYS_PAGE_MARGIN_SM,
  SYS_PAGE_MARGIN_XS,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_300,
  SYS_SPACE_RELATIVE_BP_MD_LG,
  SYS_SPACE_RELATIVE_BP_SM_2_XL,
  SYS_SPACE_RELATIVE_BP_SM_XL,
  SYS_SPACE_RELATIVE_BP_XS_XL,
  SYS_SPACE_RELATIVE_MD,
  SYS_SPACE_RELATIVE_XL,
} from '@oneaudi/unified-web-common';
import { Card, TextList } from '@oneaudi/unified-web-components';

export const HeadlineWrapper = styled.div`
  margin: 0 0 ${SYS_SPACE_RELATIVE_XL} 0;
`;

export const ProductsContainer = styled.div`
  display: grid;
  gap: ${SYS_SPACE_FIXED_200};
  width: auto;
  padding: ${SYS_SPACE_FIXED_300} 0;
  @media (min-width: ${SYS_BREAKPOINT_MD}) and (max-width: calc(${SYS_BREAKPOINT_LG} - 1px)) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) and (max-width: calc(${SYS_BREAKPOINT_XL} - 1px)) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const PaginationContainer = styled.div`
  margin-bottom: calc(${SYS_SPACE_FIXED_300} * 3);
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const SupElement = styled.span`
  vertical-align: super;
  font-size: smaller;
`;

export const PlayIconWrapper = styled.div`
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 48px;
`;

export const AdditionalProductContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTextList = styled(TextList)`
  :not(:last-child) {
    margin: 0 0 ${SYS_PAGE_MARGIN_XS} 0;
  }
`;

export const StyledConatiner = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${SYS_PAGE_MARGIN_XS};
`;

export const TextWrapper = styled.div`
  flex-basis: 25%;
  word-break: break-word;
  padding: 0 ${SYS_PAGE_MARGIN_MD} 0 0;
`;

export const TyreLabelItemStyled = styled.div`
  margin-bottom: 0 0 ${SYS_PAGE_MARGIN_2_XL} 0;
  width: 260px;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-bottom: 0;
  }
`;

export const TyreLabelImageStyled = styled.img`
  margin-bottom: 0 0 ${SYS_PAGE_MARGIN_MD} 0;
  width: 100%;
`;

export const TyreLabelListStyled = styled.div`
  margin-top: ${SYS_PAGE_MARGIN_SM};

  @media (min-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    gap: ${SYS_SPACE_RELATIVE_BP_SM_2_XL};
  }
`;

export const ModalContentContainer = styled.div`
  display: flex;
`;

export const HeadlineAndInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  @media (min-width: ${SYS_BREAKPOINT_XS}) and (max-width: calc(${SYS_BREAKPOINT_MD} - 1px)) {
    flex-direction: column;
    gap: ${SYS_SPACE_RELATIVE_BP_SM_XL};
  }
`;

export const HeadlinePanel = styled.div`
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding-top: ${SYS_SPACE_RELATIVE_BP_SM_2_XL};
    margin-right: ${SYS_SPACE_RELATIVE_BP_XS_XL};
  }
`;

export const InfoPanel = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  text-align: center;
  picture {
    display: block;
    width: 100%;
  }
  img {
    height: auto;
    width: 100%;
  }
`;

export const InfoTextContainer = styled.div`
  margin: ${SYS_SPACE_RELATIVE_MD} 0 ${SYS_SPACE_RELATIVE_XL} 0;
`;

export const InPackageProductsContainer = styled.div`
  display: grid;
  grid-auto-flow: column;

  margin: ${SYS_SPACE_RELATIVE_BP_MD_LG} 0;
  gap: ${SYS_SPACE_RELATIVE_BP_MD_LG};

  @media (min-width: ${SYS_BREAKPOINT_XS}) and (max-width: calc(${SYS_BREAKPOINT_MD} - 1px)) {
    grid-template-columns: repeat(auto-fit, minmax(216px, 1fr));
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    grid-template-columns: repeat(2, minmax(216px, 1fr));
  }
`;

export const StyledCard = styled(Card)`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const VideoOverlay = styled.div`
  position: relative;
`;

export const PictureWrapper = styled.div``;

export const PictureEl = styled.picture<{ hasVideo: boolean }>`
  filter: brightness(${(props) => (props.hasVideo ? 0.6 : 1)});
  img {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
  }
`;

export const CardText = styled.div`
  padding: ${SYS_SPACE_FIXED_200};
`;
export const StyledHeadline = styled.div`
  height: 60px;
  max-height: 60px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  line-clamp: 3;
`;
